import { useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';
import themes from '~/themes';

export function useIsMobileLandscape() {
  const isLandscape = useMediaQuery('(orientation: landscape)');
  const isMdDown = useMediaQuery(themes.breakpoints.down('lg'));
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent || (window as any).opera;
    const mobileRegex = /android|iphone|ipad|ipod|mobile|windows phone/i;
    setIsMobile(mobileRegex.test(userAgent));
  }, []);

  return isMobile && isLandscape && isMdDown;
}
